<template>
  <ListagemBase
    ref="listagem"
    nomePlural="FuncionarioSindicatos"
    nomeSingular="FuncionarioSindicato"
    :headers="headersExibicao"
    :buscaSimplificada="false"
    :buscaParametrizadaPaginada="true"
    :pesquisaDescricao="true"
    :pesquisaStatusComum="!modoSelecaoRecurso"
    :botaoCadastro="!modoSelecaoRecurso"
    :editar="!modoSelecaoRecurso"
    :modoSelecaoRecurso="modoSelecaoRecurso"
    :ocultarCabecalhoListagem="modoSelecaoRecurso"
    :keyboardShortcutsEnabled="!modoSelecaoRecurso"
    :class="{ 'listagem-modo-selecao': modoSelecaoRecurso }"
    @row-click="selecionarRecurso"
  >
    <template v-if="!modoSelecaoRecurso" v-slot:expandable-content="slotProps">
      <v-row class="pa-4">
        <v-col cols="12">
          <h2>{{ $t("Listagem_de_parametrizacoes") }}</h2>
          <v-data-table
            :headers="headersParametrizacoes"
            :items="slotProps.item.parametrizacoes"
          ></v-data-table>
        </v-col>
        <v-col cols="12">
          <h2>{{ $t("Listagem_de_rubricas") }}</h2>
          <v-data-table
            :headers="headersRubricas"
            :items="slotProps.item.rubricas"
          ></v-data-table>
        </v-col>
      </v-row>
    </template>
  </ListagemBase>
</template>

<script>
import ListagemBase from "@/components/base/Crud/ListagemBase";
import FuncionarioSindicatoDataService from "@/services/pessoal/FuncionarioSindicatoDataService";
const DataService = FuncionarioSindicatoDataService;

export default {
  name: "ListagemFuncionarioSindicato",
  components: { ListagemBase },
  props: {
    modoSelecaoRecurso: { type: Boolean, required: false, default: false },
  },
  data() {
    const dataService = this.modoSelecaoRecurso
      ? Object.assign(Object.create(DataService), {
          getPage: (params) =>
            DataService.getFilterPage({ statusComum: "ATIVO" }, params),
          getFilterPage: (payload, params) =>
            DataService.getFilterPage(
              { ...payload, statusComum: "ATIVO" },
              params
            ),
        })
      : DataService;
    return {
      DataService: dataService,

      headers: [
        { text: this.$t("Descricao"), value: "descricao", sortable: "false" },
        { text: this.$t("Status"), value: "statusComum", sortable: "false" },

        { text: this.$t("Acoes"), value: "actions", sortable: false },
      ],

      headersParametrizacoes: [
        { text: this.$t("Referencia"), value: "referencia", sortable: "false" },
        { text: this.$t("Tipo"), value: "tipo", sortable: "false" },
        { text: this.$t("Ativo"), value: "ativo", sortable: "false" },
      ],
    };
  },
  computed: {
    headersExibicao() {
      return this.modoSelecaoRecurso
        ? this.headers.filter((header) => header.value === "descricao")
        : this.headers;
    },
    possuiIntegracaoFpSIPFolhaPagamento() {
      return !!(
        this.$store.state.inquilino &&
        this.$store.state.inquilino.parametrizacoes &&
        this.$store.state.inquilino.parametrizacoes.find(
          (item) => item.tipo == "INTEGRACAO_FP_SIP_FOLHA_PAGAMENTO"
        )
      );
    },
    headersRubricas() {
      const headers = [
        { text: this.$t("Rubrica"), value: "rubrica", sortable: "false" },
        { text: this.$t("Tipo"), value: "tipo", sortable: "false" },
        {
          text: this.$t("Tipo_apuracao"),
          value: "tipoApuracao",
          sortable: "false",
        },
      ];

      if (this.possuiIntegracaoFpSIPFolhaPagamento) {
        headers.push(
          {
            text: this.$t("Tipo_apuracao_fp"),
            value: "tipoApuracaoFp",
            sortable: "false",
          },
          {
            text: this.$t("Descricao_fp"),
            value: "descricaoFp",
            sortable: "false",
          }
        );
      }

      return headers;
    },
  },
  methods: {
    selecionarRecurso(payload) {
      if (this.modoSelecaoRecurso && payload && payload.item) {
        this.$emit("selecionar-recurso", payload.item);
      }
    },
  },
};
</script>

<style scoped>
.listagem-modo-selecao::v-deep tbody tr {
  cursor: pointer;
}
</style>
